<ion-header>
  <ion-toolbar>
    <ion-title>{{ supercombinaciones ? 'Supercombinaciones' : 'Combos' }}</ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-list>
  <ion-item
    *ngFor="let item of combos; let i = index"
    button
    (click)="changeCombo(item)"
    [lines]="combos.length === i + 1 ? 'none' : undefined"
    [color]="selected.name === item.name ? 'primary' : undefined"
  >
    <ion-label>{{ item.name }}</ion-label>
  </ion-item>
</ion-list>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="start" name="close"></ion-icon>
        Cerrar
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
